import { useById } from "@hulanbv/nest-utilities-client-state";
import { FC } from "react";
import { useHistory, useParams } from "react-router-dom";
import { classes, style } from "typestyle";
import { ReactComponent as checkIcon } from "../../assets/graphics/symbols/checkmark.svg";
import { ReactComponent as crossIcon } from "../../assets/graphics/symbols/cross.svg";
import { useAuthContext } from "../../state/authentication/authentication.context";
import { dictionary } from "../../state/common/constants/dictionary.constants";
import { noteService } from "../../state/notes/note.service";
import { userService } from "../../state/user/user.service";
import { Button } from "../elements/button.element";
import { PageBody } from "../elements/page-body.element";
import { Page } from "../elements/page.element";
import Toast from "../statics/toast";
import { NoteForm } from "../templates/forms/notes/note-form.template";

export const NoteCreateScreen: FC = () => {
  const params = useParams<{ userId: string }>();
  const { data: client } = useById(
    userService,
    params.userId,
    {},
    { distinct: true },
  );

  const history = useHistory();

  const { session } = useAuthContext();

  const onSubmitForm = async (formData: FormData) => {
    try {
      await noteService.post(formData);
      history.goBack();
      Toast.info({
        body: dictionary.texts.noteCreationSuccess,
      });
    } catch {
      Toast.error({
        body: dictionary.texts.noteCreationError,
      });
    }
  };

  return (
    <Page>
      <PageBody>
        {client && session?.user && (
          <NoteForm
            user={session.user}
            client={client}
            hideSubmitButton
            onSubmit={onSubmitForm}
          >
            <div className={styles.buttonContainer}>
              <Button
                attributes={{
                  type: "submit",
                  className: classes(styles.button, styles.marginBottom),
                }}
                icon={checkIcon}
              >
                {dictionary.literals.save}
              </Button>
              <Button
                attributes={{
                  className: classes(styles.button, styles.marginBottom),
                  onClick: history.goBack,
                }}
                icon={crossIcon}
                hideSpinnerOnSubmit
                flavour={"secondary"}
              >
                {dictionary.literals.cancel}
              </Button>
            </div>
          </NoteForm>
        )}
      </PageBody>
    </Page>
  );
};

const styles = {
  buttonContainer: style({
    display: "flex",
    flexDirection: "column",
    marginTop: 40,
  }),
  button: style({
    width: "100%",
  }),
  marginBottom: style({
    marginBottom: 30,
  }),
};
